import { useEffect, useState } from 'react';

/** Vertraagt een waarde; gebruikt voor de adreszoekfunctie. */
export function useDebounce<T>(waarde: T, vertragingMs = 300): T {
  const [vertraagd, setVertraagd] = useState(waarde);

  useEffect(() => {
    const timer = setTimeout(() => setVertraagd(waarde), vertragingMs);
    return () => clearTimeout(timer);
  }, [waarde, vertragingMs]);

  return vertraagd;
}
